/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCogs} from '@fortawesome/pro-duotone-svg-icons';

const SettingsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCogs} {...props} />
);

export default SettingsIcon;
